export const extraZh = {
  serviceLayout: {
    ctaTitle: "准备好开始了吗？",
    defaultCta: "预约咨询",
    images: {
      courses: {
        heroAlt: "团队在白板前讨论课程结构和学习路径",
        heroCaption: "结构化训练比碎片化技巧更能形成长期影响力",
        contentAlt: "讲师在课堂中讲解内容策略",
      },
      operations: {
        heroAlt: "运营团队查看增长数据看板",
        heroCaption: "稳定增长来自可执行、可复盘的流量结构",
        contentAlt: "数字增长图表和关键指标分析",
      },
      ecommerce: {
        heroAlt: "电商团队在仓储场景中协同工作",
        heroCaption: "电商增长需要内容、转化和履约协同",
        contentAlt: "线上商城订单和商品管理界面",
      },
      interview: {
        heroAlt: "两位嘉宾在采访现场对谈",
        heroCaption: "权威表达需要真实场景与持续输出",
        contentAlt: "摄影棚中的专业采访设备",
      },
      activity: {
        heroAlt: "大型活动现场与舞台演讲",
        heroCaption: "一次活动内容可拆分为多平台长期资产",
        contentAlt: "活动现场观众与互动画面",
      },
      certification: {
        heroAlt: "商务人士交换名片建立信任",
        heroCaption: "高风险行业增长先解决信任门槛",
        contentAlt: "认证文件与商务签署场景",
      },
      webDev: {
        heroAlt: "开发者在笔记本上搭建网站系统",
        heroCaption: "现代官网既服务用户，也服务搜索与 AI",
        contentAlt: "代码编辑器中的前端工程项目",
      },
      consulting: {
        heroAlt: "顾问团队在会议室制定业务策略",
        heroCaption: "战略重构的关键是把复杂问题系统化",
        contentAlt: "团队在透明玻璃墙上规划增长路线图",
      },
      matrix: {
        heroAlt: "跨部门团队围绕品牌矩阵做协同规划",
        heroCaption: "矩阵系统用于放大同一品牌的多入口触达",
        contentAlt: "团队在工作区协同处理多渠道任务",
      },
      ipIncubation: {
        heroAlt: "创始人团队讨论个人品牌孵化策略",
        heroCaption: "IP 孵化不是包装，而是长期表达系统建设",
        contentAlt: "创作者团队在会议中讨论内容方向",
      },
      teamExpression: {
        heroAlt: "团队成员在会议中进行统一表达训练",
        heroCaption: "团队表达一致性直接影响品牌信任感",
        contentAlt: "小组协同演练对外表达和沟通",
      },
      contact: {
        heroAlt: "顾问与客户在会议桌前沟通需求",
        heroCaption: "从一次咨询开始，建立可持续增长结构",
        contentAlt: "商务会议桌上的笔记本与沟通记录",
      },
      default: {
        heroAlt: "现代商务团队在办公室进行协作",
        heroCaption: "系统化协同让增长更稳定",
        contentAlt: "企业团队在会议中复盘业务数据",
      },
    },
  },
  pages: {
    activity: { title: "活动影响力放大系统", subtitle: "一场活动，不应该只存在一天", cta: "预约活动视频方案" },
    certification: { title: "数字信任基础设施系统", subtitle: "认证不是标识，是数字时代的信任入口", cta: "申请专业号认证" },
    consulting: { title: "影响力战略重构咨询", subtitle: "有些问题不是执行问题，是结构问题", cta: "预约一对一深度咨询" },
    courses: { title: "自媒体影响力架构训练营", subtitle: "不是教你拍视频，是教你建立影响力系统", cta: "查看课程包" },
    ecommerce: { title: "电商增长结构系统", subtitle: "电商真正的难点不是卖产品，是建立增长结构", cta: "获取电商与直播方案" },
    interview: { title: "权威影响力放大系统", subtitle: "采访不是视频，是影响力杠杆", cta: "预约采访方案" },
    matrix: { title: "立体影响力矩阵系统", subtitle: "不是多开几个账号，而是建立全维度覆盖系统", cta: "查看矩阵搭建方案" },
    ipIncubation: { title: "全网立体IP架构系统", subtitle: "我们不做账号运营，我们构建立体IP系统", cta: "申请IP孵化方案" },
    operations: { title: "短视频流量结构运营系统", subtitle: "我们不帮你发视频，我们为你搭建持续流量引擎", cta: "获取代运营方案" },
    teamExpression: { title: "表达能力架构系统", subtitle: "在数字时代，表达能力就是生产力", cta: "预约表达与出镜方案" },
    webDev: { title: "数字基础设施网站", subtitle: "不是做一个好看的网站，而是建立一个可被发现的系统", cta: "预约网站方案" },
    contact: { title: "联系我们", subtitle: "获取专属增长方案，预约策略会议", cta: "预约策略会议" },
  },
  serviceDetail: {
    common: {
      introTitle: "为什么要做系统化升级",
      introParagraphs: [
        "短期内容可以带来曝光，但无法稳定带来高质量增长。",
        "真正有效的是可复用、可沉淀、可持续迭代的结构化系统。",
      ],
      emphasis: "先搭系统，再做放大，增长才会越来越稳。",
      sections: [
        {
          title: "核心能力",
          items: [
            { title: "结构诊断", desc: "先识别增长瓶颈，再确定优先级与路径。" },
            { title: "内容系统", desc: "建立可复用表达框架，而不是一次性爆款逻辑。" },
            { title: "搜索与 AI", desc: "让内容可被发现、可被理解、可被长期引用。" },
          ],
        },
        {
          title: "执行方式",
          items: [
            { title: "分阶段推进", desc: "按目标拆分阶段，逐步扩展，避免无序投入。" },
            { title: "跨平台协同", desc: "短视频、官网、搜索和私域形成闭环。" },
            { title: "持续复盘", desc: "用数据迭代结构，而不是只看单次播放结果。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["高客单行业团队", "需要长期品牌建设", "希望多语言扩展", "重视搜索与 AI 入口"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "多久能看到变化？", a: "通常 2-4 周看到结构变化，8-12 周看到更稳定结果。" },
        { q: "是否支持多语言？", a: "支持，且后续可继续扩展更多语种。" },
        { q: "是否可以分阶段合作？", a: "可以，建议先做最关键模块，再逐步扩展。" },
      ],
      outro: ["增长不是单点技巧。", "增长是系统工程。"],
    },
    webDev: {
      introTitle: "网站不是名片，而是增长基础设施",
      introParagraphs: [
        "在 2025 年之后，网站的价值不再只是展示，而是是否可被搜索、可被 AI 理解、可被持续引用。",
        "我们做的不是“做一个好看页面”，而是构建一个面向人、搜索引擎和 AI 的三层系统。",
        "网站必须成为你全平台内容网络的中心节点，而不是孤立页面。",
      ],
      emphasis: "一半给人看，一半给搜索引擎和 AI 看。",
      sections: [
        {
          title: "三层网站架构",
          items: [
            { title: "人类体验层", desc: "清晰导航、转化路径、视觉信任与案例表达，确保访客能快速理解并行动。" },
            { title: "搜索结构层", desc: "关键词分层、标题语义、内链逻辑与可抓取结构，提升长期自然流量能力。" },
            { title: "AI 可读层", desc: "问答化段落、结构化数据、语义清晰表达，提升在 AI 问答中的可见与可引用性。" },
          ],
        },
        {
          title: "核心交付模块",
          items: [
            { title: "SEO + Schema", desc: "搭建基础 SEO 架构、FAQ 与 Schema 标注，建立可发现和可理解的技术底座。" },
            { title: "多语言框架", desc: "支持中英双语并可扩展西语，处理关键词差异与本地化表达，而非机械翻译。" },
            { title: "内容沉淀系统", desc: "支持博客/专题页扩展，把短视频、采访、活动内容沉淀为长尾资产。" },
            { title: "转化与系统对接", desc: "表单自动化、CRM 对接与承接路径设计，让流量进入可追踪的业务闭环。" },
          ],
        },
        {
          title: "联动与放大",
          items: [
            { title: "全平台联动", desc: "网站与短视频、社交媒体、搜索和 AI 入口协同，形成统一内容网络。" },
            { title: "线上线下闭环", desc: "线下活动、采访、社交内容回流到网站，持续强化信任和搜索资产。" },
            { title: "长期资产复利", desc: "持续积累可被检索、可被引用、可被复用的内容，而不是只追求短期流量峰值。" },
          ],
        },
        {
          title: "网站开发服务清单",
          items: [
            { title: "网站类型规划", desc: "品牌型官网、营销型官网、管理型网站、电商网站一站式规划。" },
            { title: "品牌梳理与架构规划", desc: "梳理品牌表达与信息架构，明确转化路径。" },
            { title: "视觉设计与前端开发", desc: "定制 UI 设计与前端开发，非模板套版。" },
            { title: "自适应布局", desc: "适配手机、平板与电脑多端体验。" },
            { title: "功能开发与系统对接", desc: "表单、预约、博客/资讯，对接邮件/WhatsApp/微信/CRM 等工具。" },
            { title: "SEO 基础配置", desc: "关键词布局、标题描述优化与基础站内 SEO。" },
            { title: "部署上线与培训交付", desc: "服务器/域名部署与基础运维培训，便于后续更新。" },
            { title: "可选 APP 定制", desc: "支持原创定制 iOS/Android 应用项目。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["高客单与高信任行业", "希望长期做品牌资产", "需要多语言和多族裔触达", "希望获得 SEO 与 AI 双入口"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "你们做的是网站设计还是增长系统？", a: "我们交付的是网站增长系统，设计只是其中一层，核心是结构、语义和转化闭环。" },
        { q: "是否考虑 AI 搜索与问答平台？", a: "会。我们会设计 AI 可读结构、FAQ 模块与结构化数据，提升被模型理解与引用的概率。" },
        { q: "支持中英双语吗？", a: "支持，并可扩展更多语种。我们会做语义和关键词本地化，而不是仅做字面翻译。" },
        { q: "是否能与短视频和社媒联动？", a: "可以。网站会作为内容沉淀中心，与短视频、社媒与搜索形成协同闭环。" },
        { q: "预算和周期怎么评估？", a: "根据页面规模、语言版本、内容深度与系统对接复杂度评估，建议先做结构诊断再定范围。" },
      ],
      outro: ["网站不是一次性交付。", "网站是可持续增长的基础设施。"],
    },
    ipIncubation: {
      introTitle: "我们不做账号运营，我们构建立体 IP 系统",
      introParagraphs: [
        "在数字时代，IP 不属于某一个平台，而属于全网入口、语义系统与长期信任资产。",
        "如果影响力只存在于单平台，那只是账号，不是 IP。",
        "我们用内容、平台、语义、信任、变现五层结构，把个人或团队能力升级为可持续影响力系统。",
      ],
      emphasis: "全网 · 全语言 · 全入口 · 可持续。",
      sections: [
        {
          title: "立体 IP 五层模型",
          items: [
            { title: "内容层", desc: "短视频、长视频、深度文章、采访与活动沉淀协同表达同一核心立场。" },
            { title: "平台层", desc: "TikTok、YouTube、Instagram、小红书、视频号、搜索与 AI 入口协同布局。" },
            { title: "语义层", desc: "通过 FAQ、关键词结构与 Schema，提升搜索可见性与 AI 理解能力。" },
            { title: "信任层", desc: "案例、采访、认证与媒体背书共同构建可迁移的行业信任。" },
            { title: "变现层", desc: "咨询产品化、服务分层与承接路径设计，形成可复利商业闭环。" },
          ],
        },
        {
          title: "交付路径",
          items: [
            { title: "定位架构设计", desc: "明确行业位置、核心标签和差异化立场，建立长期表达主线。" },
            { title: "内容网络搭建", desc: "构建跨平台内容节奏与网站沉淀页，避免单点爆款后断流。" },
            { title: "AI 可见性设计", desc: "搭建问答结构、FAQ 页面与语义模板，提升在 AI 场景的被引用能力。" },
            { title: "信任资产沉淀", desc: "用真实场景、案例和权威表达，持续强化决策前信任。" },
          ],
        },
        {
          title: "执行方式",
          items: [
            { title: "项目制陪跑", desc: "按周策略会、方向复盘、表达训练与结构迭代，持续推进结果。" },
            { title: "跨团队协同", desc: "内容、运营、站点与转化模块协同，确保每个动作服务同一目标。" },
            { title: "数据驱动优化", desc: "同时看流量、搜索、咨询与转化信号，避免只看播放量指标。" },
          ],
        },
        {
          title: "IP 孵化服务内容",
          items: [
            { title: "精准人设与话术标签", desc: "打造清晰人设定位与表达标签，提升记忆度。" },
            { title: "内容与选题矩阵", desc: "形成可持续输出的内容与选题体系。" },
            { title: "多账号流量布局", desc: "多平台协同布局，扩大自然流量入口。" },
            { title: "变现路径设计", desc: "梳理咨询与服务承接节奏，建立可复利闭环。" },
            { title: "项目制深度陪跑", desc: "按项目节奏推进，提供策略与执行支持。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["高客单行业创始人或核心团队", "希望跨平台做长期品牌", "需要兼顾 SEO 与 AI 可见性", "已有业务基础并愿意系统化升级"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "IP 孵化是否只做某个平台？", a: "不是。我们做的是全网立体系统，而不是单平台账号代运营。" },
        { q: "是否包含网站与搜索优化？", a: "包含。我们会同步设计网站沉淀结构、FAQ、SEO 与 AI 可读层。" },
        { q: "多久可以看到变化？", a: "通常 2-4 周看到结构变化，8-12 周看到更稳定的增长与线索信号。" },
        { q: "是否承诺行业第一或爆款？", a: "不承诺排名或爆款。我们承诺的是结构完整、表达清晰和可持续迭代机制。" },
        { q: "适合完全零基础吗？", a: "可评估，但更适合已有业务基础、希望从账号思维升级到系统思维的团队。" },
      ],
      outro: ["IP 不是平台资产。", "IP 是可持续影响力资产。"],
    },
    operations: {
      introTitle: "短视频运营不是发内容，而是流量结构工程",
      introParagraphs: [
        "平台流量本质是结构分配，不是随机奖励。",
        "我们通过内容节奏、入口策略、搜索协同和数据复盘，建立持续流量引擎。",
        "目标不是单条爆发，而是稳定获取线索与品牌资产沉淀。",
      ],
      emphasis: "做运营，不做运气。",
      sections: [
        {
          title: "流量结构设计",
          items: [
            { title: "内容分层", desc: "搭建引流层、信任层、转化层内容，避免所有内容都承担同一目标。" },
            { title: "入口协同", desc: "推荐流、搜索流、主页与官网承接联动，形成完整增长路径。" },
            { title: "节奏管理", desc: "按周设定内容节奏与复盘节点，避免高频输出但低效积累。" },
          ],
        },
        {
          title: "执行与优化",
          items: [
            { title: "选题系统", desc: "围绕客户问题和业务目标设计可复用选题池，不依赖临场灵感。" },
            { title: "指标体系", desc: "同时跟踪完播、互动、搜索、私信与线索质量，不只看播放量。" },
            { title: "迭代机制", desc: "持续复盘标题、开场、结构和 CTA，让增长路径可解释、可复制。" },
          ],
        },
        {
          title: "代运营服务内容",
          items: [
            { title: "账号体检与策略规划", desc: "诊断现状并制定阶段目标与执行节奏。" },
            { title: "账号搭建与视觉", desc: "账号结构、视觉统一与基础规范。" },
            { title: "内容与选题策划", desc: "选题池与内容结构规划，降低输出不确定性。" },
            { title: "文案改写", desc: "优化标题、开场与结构，提高停留与转化。" },
            { title: "探店拍摄取材", desc: "场景化素材采集与脚本执行。" },
            { title: "剪辑与包装", desc: "完成剪辑、字幕、节奏与封面优化。" },
            { title: "评论互动与矩阵分发", desc: "强化互动、分发与矩阵协同。" },
            { title: "发布排期与搜索管理", desc: "稳定节奏与搜索标签结构管理。" },
            { title: "营销投流与私域基础运营", desc: "需要时进行投流与私域承接优化。" },
            { title: "数据监测与复盘", desc: "按周复盘指标与内容表现。" },
            { title: "咨询服务", desc: "持续给出结构与执行建议。" },
          ],
        },
        {
          title: "内容产出方向",
          items: [
            { title: "人设视频", desc: "强化个人形象与专业可信度。" },
            { title: "搜索型视频", desc: "聚焦关键词与高意向问题。" },
            { title: "流量型视频", desc: "扩大触达与曝光入口。" },
            { title: "营销型视频", desc: "强化转化与行动引导。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["有明确业务目标的团队", "希望稳定获取高质量线索", "需要短视频与官网协同", "愿意按数据持续迭代"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "你们是代发视频吗？", a: "不是单纯代发。我们做的是流量结构设计与运营系统搭建。" },
        { q: "多久能看到变化？", a: "通常 2-4 周看到结构指标变化，8-12 周看到更稳定的业务信号。" },
        { q: "是否包含搜索与 AI 可见性？", a: "包含。我们会把短视频内容与站点沉淀、FAQ 和搜索入口打通。" },
      ],
      outro: ["短视频运营不是内容堆量。", "是可持续增长工程。"],
    },
    matrix: {
      introTitle: "矩阵不是多开账号，而是全维度覆盖系统",
      introParagraphs: [
        "单平台多账号只是账号矩阵，不是影响力矩阵。",
        "我们构建的是平台、语言、入口、内容形态与角色分工协同的立体系统。",
        "目标是扩大有效触达面，并把流量统一沉淀为品牌资产。",
      ],
      emphasis: "多账号是形式，多维覆盖才是本质。",
      sections: [
        {
          title: "五维矩阵模型",
          items: [
            { title: "平台维度", desc: "不同平台承担不同职责: 曝光、深度、搜索与承接。" },
            { title: "人群维度", desc: "按客户决策阶段拆分内容与话术，覆盖不同意图人群。" },
            { title: "语言维度", desc: "中英双语结构化表达，扩大北美多族裔市场触达。" },
            { title: "内容维度", desc: "短视频、访谈、FAQ、案例与官网深度页形成联动网络。" },
            { title: "数据维度", desc: "统一看板监测入口表现与转化链路，持续调整资源分配。" },
          ],
        },
        {
          title: "运营机制",
          items: [
            { title: "角色分工", desc: "创始人号、品牌号、场景号协同表达，避免内容内耗。" },
            { title: "素材中台", desc: "建立可复用素材库，提高跨平台生产效率与一致性。" },
            { title: "闭环承接", desc: "所有矩阵入口最终回流到官网与咨询系统，形成可追踪闭环。" },
          ],
        },
        {
          title: "矩阵号搭建",
          items: [
            { title: "品牌号", desc: "统一输出品牌形象与核心卖点，承接官方咨询与转化。" },
            { title: "老板 IP 号", desc: "以个人故事与专业输出建立信任感，提升粉丝粘性。" },
            { title: "分身号矩阵", desc: "布局不同圈层与兴趣标签，扩大自然流量入口。" },
            { title: "多账号联动", desc: "一个品牌多入口触达，持续放大获客池。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["已经有内容基础的团队", "需要多平台稳定曝光", "希望统一品牌表达和转化", "准备做中长期矩阵布局"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "矩阵一定要很多账号吗？", a: "不一定。关键是入口与角色分工，而不是账号数量本身。" },
        { q: "会不会导致内容重复？", a: "我们会按平台角色做结构重写，保持核心一致但表达差异化。" },
        { q: "矩阵如何衡量效果？", a: "通过入口覆盖、搜索表现、线索质量与转化效率综合评估。" },
      ],
      outro: ["矩阵不是堆账号。", "矩阵是覆盖系统。"],
    },
    courses: {
      introTitle: "这不是拍视频课程，而是影响力架构训练营",
      introParagraphs: [
        "多数课程只教技巧，难以形成长期竞争力。",
        "我们的训练营核心是: 定位、内容、搜索、信任、变现五层结构。",
        "你学到的不只是输出内容，而是设计可复用的影响力系统。",
      ],
      emphasis: "先学系统，再学技巧。",
      sections: [
        {
          title: "训练核心模块",
          items: [
            { title: "定位架构", desc: "建立清晰标签与差异化立场，让客户快速记住你。" },
            { title: "内容结构", desc: "掌握可复用内容模型，让输出稳定且可迭代。" },
            { title: "搜索与 AI", desc: "把表达延伸到搜索和 AI 入口，形成长尾复利。" },
            { title: "信任构建", desc: "设计案例、采访与权威表达，提升决策前信任度。" },
            { title: "变现路径", desc: "搭建咨询与服务承接结构，避免只有流量没有转化。" },
          ],
        },
        {
          title: "训练方式",
          items: [
            { title: "结构化训练", desc: "按周推进，阶段复盘，确保每个模块都能落地执行。" },
            { title: "实战作业", desc: "围绕真实业务问题输出内容，不做脱离业务的演练。" },
            { title: "模板工具", desc: "提供框架、清单和 SOP，帮助团队持续复用。" },
          ],
        },
        {
          title: "课程包一｜超然自媒体获客爆款模型",
          items: [
            { title: "账号定位与选题逻辑", desc: "从零起步建立标签，让搜索更容易找到你。" },
            { title: "短视频文案拆解与爆款结构", desc: "八大模板拆解，强化内容表达与吸引力。" },
            { title: "拍摄与剪辑", desc: "六大拍摄剪辑技巧，提升画面与节奏感。" },
            { title: "内容实现与转化", desc: "拍剪一体实操，推动从内容到咨询转化。" },
            { title: "无人机课程", desc: "理论 + 实操训练，拓展场景化拍摄能力。" },
          ],
        },
        {
          title: "课程包一｜配套服务",
          items: [
            { title: "四周自媒体搜索课程", desc: "围绕搜索与标签建立可持续获客路径。" },
            { title: "海外视频号开通支持", desc: "协助完成账号开通与基础设置。" },
            { title: "专业号协助开通", desc: "小红书/视频号专业号开通与流程指导。" },
            { title: "私域引流与自动回复", desc: "小红书自动回复、私域引流与聚光支持。" },
            { title: "文案指导与工具包", desc: "提供文案指导与自媒体工具清单。" },
            { title: "复训支持", desc: "三个月内可多次复训与答疑。" },
            { title: "阶段性代运营支持", desc: "提供高端用户代运营支持与实战辅导。" },
            { title: "无人机使用支持", desc: "结合课程提供场景化拍摄协助。" },
          ],
        },
        {
          title: "课程包二｜超然电商黑科技实战营",
          items: [
            { title: "SEO流量破局课", desc: "起号逻辑与标签定位，构建电商账号基础结构。" },
            { title: "爆款电商视频炼成", desc: "强转化模板拆解，沉淀可复用脚本。" },
            { title: "实操冲刺营", desc: "手把手完成好物推荐与带货视频。" },
            { title: "带货直播攻略", desc: "表现力训练、选品、话术与流量参数。" },
            { title: "AI带货提效课", desc: "AI辅助选品、脚本与话术，提升内容效率。" },
          ],
        },
        {
          title: "课程包二｜配套服务",
          items: [
            { title: "五周电商课程", desc: "完整电商训练节奏与课后任务安排。" },
            { title: "美网 TikTok 介入支持", desc: "提供平台介入与基础操作协助。" },
            { title: "直播话术手册", desc: "提供高转化直播话术框架。" },
            { title: "橱窗开通协助", desc: "协助完成橱窗申请与基础配置。" },
            { title: "文案指导与工具包", desc: "提供文案指导与自媒体工具清单。" },
            { title: "复训支持", desc: "三个月内可多次复训与答疑。" },
            { title: "AI软件支持", desc: "提供 AI 工具使用建议与效率提升方案。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["本地商家与连锁品牌", "工作室/本地服务商/自媒体创业者", "电商卖家与个人 IP 带货", "品牌自播与供应链团队"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "这是纯新手课程吗？", a: "可参与，但更适合已有业务基础、希望系统升级的团队。" },
        { q: "是否保证爆款？", a: "不保证爆款。我们交付的是可持续结构和稳定增长能力。" },
        { q: "课程后可以继续合作吗？", a: "可以，可衔接运营系统或专项陪跑，延续执行效果。" },
      ],
      outro: ["课程结束不是终点。", "系统能力才是护城河。"],
    },
    ecommerce: {
      introTitle: "电商增长的核心不是卖货，而是增长结构",
      introParagraphs: [
        "短期销量可以靠活动拉动，长期增长必须靠系统协同。",
        "我们将内容、搜索、承接页面、信任资产和转化路径打通。",
        "目标是让每一份流量都进入可复用的增长网络。",
      ],
      emphasis: "电商不是流量游戏，是结构工程。",
      sections: [
        {
          title: "增长结构模块",
          items: [
            { title: "内容获客", desc: "以场景化内容吸引精准人群，提升自然触达效率。" },
            { title: "搜索承接", desc: "通过关键词布局与专题页承接，提升高意向流量转化。" },
            { title: "信任强化", desc: "用案例、评价、采访和资质证明降低决策阻力。" },
            { title: "转化漏斗", desc: "优化咨询、下单、复购路径，提升全链路效率。" },
          ],
        },
        {
          title: "运营机制",
          items: [
            { title: "选品与内容协同", desc: "让内容围绕利润结构与客群需求，而非随机发布。" },
            { title: "跨渠道联动", desc: "短视频、社媒、搜索、官网和私域形成统一漏斗。" },
            { title: "数据复盘", desc: "按周追踪流量质量、转化率、客单和复购信号。" },
          ],
        },
        {
          title: "直播运营托管",
          items: [
            { title: "直播间搭建", desc: "搭直播间、定流程、写话术，明确直播节奏。" },
            { title: "运营与复盘", desc: "运营执行、数据监测与复盘优化。" },
            { title: "出镜协同", desc: "你专注产品与出镜，我们负责运营系统。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["跨境与本地电商团队", "高客单或复杂决策产品", "希望建立长期品牌复利", "需要内容与转化协同"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "你们只做投流吗？", a: "不是。我们重点是自然增长结构与转化承接系统，投流可作为放大工具。" },
        { q: "是否支持多语言电商？", a: "支持，可按语言市场设计关键词、页面结构与表达方式。" },
        { q: "可以与 IP 系统联动吗？", a: "可以。IP 与电商协同通常能显著提升信任和转化效率。" },
      ],
      outro: ["电商长期增长靠结构。", "不是靠一次爆单。"],
    },
    interview: {
      introTitle: "采访不是内容形式，而是权威影响力基础设施",
      introParagraphs: [
        "高客单行业的核心是信任，而信任需要被看见与被验证。",
        "采访系统可以把专业观点、真实场景与第三方视角沉淀为长期资产。",
        "我们帮助你把一次采访变成可分发、可搜索、可引用的内容网络。",
      ],
      emphasis: "采访不是拍一条视频，是搭一层信任结构。",
      sections: [
        {
          title: "采访系统设计",
          items: [
            { title: "议题设计", desc: "围绕客户决策问题设计议题，而不是泛内容访谈。" },
            { title: "表达框架", desc: "打磨叙事结构、观点顺序与关键信息密度，提升专业感。" },
            { title: "内容拆分", desc: "一场采访拆分为短视频、长视频、图文和 FAQ，多入口分发。" },
          ],
        },
        {
          title: "信任沉淀路径",
          items: [
            { title: "官网深度页", desc: "把采访转化为可搜索、可引用的长期页面资产。" },
            { title: "权威背书层", desc: "联动行业人物、案例与活动现场，强化外部可信度。" },
            { title: "转化承接", desc: "在关键节点设置咨询与行动入口，把信任转化为线索。" },
          ],
        },
        {
          title: "采访类视频服务",
          items: [
            { title: "采访策划", desc: "根据受众与业务目标制定采访方向与提纲。" },
            { title: "现场拍摄", desc: "专业拍摄、收音与灯光，确保表达质感。" },
            { title: "后期制作", desc: "多版本剪辑与内容拆分，适配不同平台发布。" },
            { title: "时长与形式定制", desc: "根据内容深度与传播需求灵活设计。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["高信任行业个人品牌", "需要建立权威形象团队", "已有内容但信任弱", "希望提升高客单转化"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "采访适合所有行业吗？", a: "更适合高客单、决策链较长、需要信任验证的行业。" },
        { q: "采访内容会不会很难持续？", a: "我们会做议题池和拆分机制，确保持续输出而非一次性制作。" },
        { q: "采访如何带来业务结果？", a: "通过官网沉淀、搜索曝光与承接路径，把权威表达转化为咨询线索。" },
      ],
      outro: ["权威来自持续表达。", "采访是信任放大器。"],
    },
    activity: {
      introTitle: "活动不该只活一天，应该成为长期影响力资产",
      introParagraphs: [
        "很多活动结束即归零，价值没有被沉淀。",
        "我们把活动从“现场事件”升级为“内容资产工程”。",
        "通过结构化拆分与跨平台分发，让一次活动持续创造流量和信任。",
      ],
      emphasis: "一次活动，多次扩散，长期沉淀。",
      sections: [
        {
          title: "活动放大结构",
          items: [
            { title: "会前预热", desc: "围绕主题、人群和议题预热，提前锁定目标关注。" },
            { title: "会中采集", desc: "按内容目标采集演讲、互动、观点和案例素材。" },
            { title: "会后拆分", desc: "拆分为短视频、图文、长文、FAQ 与专题页持续分发。" },
          ],
        },
        {
          title: "资产沉淀与转化",
          items: [
            { title: "搜索沉淀", desc: "把活动观点沉淀为可检索页面，提高长期可见性。" },
            { title: "信任证明", desc: "现场画面、嘉宾言论和用户反馈构成品牌信任证据。" },
            { title: "业务承接", desc: "把活动流量导入咨询或服务路径，形成实际业务转化。" },
          ],
        },
        {
          title: "活动视频服务",
          items: [
            { title: "活动内容采集", desc: "根据活动流程采集演讲、互动与重点环节。" },
            { title: "现场快速成片", desc: "提供活动期间或结束后的剪辑成片支持。" },
            { title: "多版本输出", desc: "适配短视频、回顾片与宣传片的不同节奏。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["经常办线上线下活动团队", "需要提高活动 ROI 的品牌", "希望活动资产长期复用", "重视品牌信任建设"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "活动结束后还能持续增长吗？", a: "可以。关键是会后内容拆分和站点沉淀结构是否提前设计好。" },
        { q: "你们只做拍摄吗？", a: "不是。我们做的是活动影响力放大系统，包括结构设计、内容拆分和承接。" },
        { q: "如何衡量活动放大效果？", a: "通过曝光质量、搜索收录、咨询转化和内容复用效率综合评估。" },
      ],
      outro: ["活动是影响力起点。", "不是影响力终点。"],
    },
    certification: {
      introTitle: "认证不是标识，而是数字信任基础设施",
      introParagraphs: [
        "在高风险与高客单行业，用户先判断可信，再考虑成交。",
        "认证体系需要和内容表达、官网结构、案例证明联动。",
        "我们帮助你把资质与信任证据转化为可理解、可搜索、可转化的结构。",
      ],
      emphasis: "先建立信任门槛，再放大流量效率。",
      sections: [
        {
          title: "数字信任结构",
          items: [
            { title: "资质可视化", desc: "把证书、合规信息与服务边界结构化呈现，降低决策不确定性。" },
            { title: "证明链路", desc: "认证、采访、案例与客户反馈形成完整信任链。" },
            { title: "语义表达", desc: "用清晰术语和 FAQ 回答关键疑问，提升搜索与 AI 理解。" },
          ],
        },
        {
          title: "落地执行",
          items: [
            { title: "信任页面体系", desc: "建立资质页、流程页、风险说明页与常见问题页。" },
            { title: "跨平台一致表达", desc: "短视频、官网和咨询话术一致，避免认知冲突。" },
            { title: "转化配套", desc: "在高信任节点设置咨询入口，提升有效线索比例。" },
          ],
        },
        {
          title: "账号开通与专业号认证",
          items: [
            { title: "视频号/小红书认证", desc: "支持企业号与个人号认证流程。" },
            { title: "高风控行业经验", desc: "擅长金融、地产、理财、贷款、保险、移民置业等行业审核。" },
            { title: "平台与账号类型选择", desc: "根据业务目标匹配小红书、抖音、视频号等平台。" },
            { title: "资质与材料准备", desc: "协助准备企业资质、业务范围与品牌材料。" },
            { title: "账号命名与合规", desc: "设计更易通过的账号名称与定位。" },
            { title: "蓝 V 认证 + 视频号开通", desc: "完成认证与开通，让客户更快搜索到你。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["金融保险与合规行业", "移民与教育咨询服务", "高客单专业服务机构", "需要提升线上信任转化率"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "有认证就一定能转化吗？", a: "不一定。需要把认证放进完整信任结构与咨询路径中，才能发挥价值。" },
        { q: "是否包含官网信任页搭建？", a: "包含。我们会同步设计资质表达、FAQ 与承接入口。" },
        { q: "适合低客单业务吗？", a: "更适合高信任决策行业，低客单业务可按轻量模型配置。" },
      ],
      outro: ["认证是信任入口。", "结构决定转化效率。"],
    },
    teamExpression: {
      introTitle: "团队表达不是话术统一，而是品牌认知统一",
      introParagraphs: [
        "很多团队有内容输出，但对外表达不一致，导致信任损耗。",
        "我们把团队表达升级为可训练、可复用、可规模化的表达系统。",
        "让创始人、销售、顾问和运营在同一叙事框架下协同输出。",
      ],
      emphasis: "表达一致性，就是品牌生产力。",
      sections: [
        {
          title: "表达架构设计",
          items: [
            { title: "核心叙事主线", desc: "定义品牌立场、关键词和价值主张，统一对外核心表达。" },
            { title: "角色话术体系", desc: "为不同岗位设计对应表达模板，保持一致又保留角色特色。" },
            { title: "场景化模板", desc: "覆盖短视频、直播、私信、咨询和线下沟通多场景表达。" },
          ],
        },
        {
          title: "训练与落地",
          items: [
            { title: "表达训练营", desc: "通过结构化训练提升镜头表达、逻辑组织和回应能力。" },
            { title: "内容共创机制", desc: "建立团队共创流程，让表达从个人能力变成组织能力。" },
            { title: "评估与迭代", desc: "基于用户反馈与转化结果持续优化表达策略和模板。" },
          ],
        },
        {
          title: "团队代替出镜服务",
          items: [
            { title: "出镜方案评估", desc: "评估视频所需人数、内容方向与时长安排。" },
            { title: "团队代替老板出镜", desc: "由团队成员代替老板完成真人出镜拍摄。" },
            { title: "批量交付", desc: "适合批量视频产出并在一年内完成交付节奏。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["团队型服务机构", "创始人带队品牌", "需要多成员对外表达", "希望提升咨询转化一致性"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "这和普通话术培训有什么不同？", a: "我们做的是系统架构，不是单次培训。重点是长期一致表达与组织复用。" },
        { q: "是否只针对创始人？", a: "不是。核心是团队协同表达，创始人与关键岗位会同时覆盖。" },
        { q: "如何衡量表达系统有效性？", a: "看内容一致性、沟通效率、线索质量和转化率等综合指标。" },
      ],
      outro: ["表达能力是组织资产。", "一致表达放大品牌价值。"],
    },
    consulting: {
      introTitle: "战略咨询不是给建议，而是重构增长系统",
      introParagraphs: [
        "当增长长期不稳，问题通常不在执行，而在结构。",
        "我们从业务目标倒推内容、渠道、信任、搜索与转化架构。",
        "目标是建立可执行、可衡量、可持续迭代的战略系统。",
      ],
      emphasis: "先重构结构，再提升执行效率。",
      sections: [
        {
          title: "战略诊断框架",
          items: [
            { title: "增长瓶颈识别", desc: "识别流量、信任、承接和组织协同的核心约束。" },
            { title: "优先级路径", desc: "明确阶段目标和资源分配，避免多线并行造成内耗。" },
            { title: "风险控制", desc: "提前定义边界和验收标准，降低试错成本。" },
          ],
        },
        {
          title: "重构输出",
          items: [
            { title: "系统蓝图", desc: "形成内容、渠道、站点、AI 可见性与转化的一体化蓝图。" },
            { title: "执行路线图", desc: "拆解为周/月节奏，确保团队可以按步骤落地。" },
            { title: "复盘机制", desc: "建立数据复盘与决策机制，让系统持续进化。" },
          ],
        },
        {
          title: "自媒体一对一深度咨询",
          items: [
            { title: "高密度策略咨询", desc: "面向个人/IP/老板，聚焦可落地执行的方案。" },
            { title: "问题拆解与路径设计", desc: "不闲聊，只解决关键增长问题。" },
            { title: "阶段性执行建议", desc: "给出可执行动作与优先级排序。" },
          ],
        },
      ],
      fitTitle: "适合谁",
      fitItems: ["已有投入但增长不稳团队", "跨平台协同混乱的组织", "高客单高信任行业", "需要阶段性战略重构公司"],
      faqTitle: "常见问题 FAQ",
      faqs: [
        { q: "咨询会不会停留在理论层面？", a: "不会。我们交付结构方案和执行路径，并配套验收与复盘机制。" },
        { q: "是否包含团队落地支持？", a: "可按合作范围提供阶段陪跑，帮助关键模块落地。" },
        { q: "怎么判断是否需要战略重构？", a: "当流量、转化、团队协同长期波动且难以解释时，通常需要结构级重构。" },
      ],
      outro: ["增长不是多做几件事。", "而是做对关键结构。"],
    },
  },
  contact: {
    cards: [
      { label: "电话", value: "4373624422" },
      { label: "微信", value: "" },
      { label: "邮箱", value: "info@traffynity.com" },
    ],
    formTitle: "预约策略会议",
    name: "姓名",
    namePlaceholder: "您的姓名",
    channel: "联系方式",
    channelPlaceholder: "手机号 / 微信 / 邮箱",
    need: "您的需求",
    needPlaceholder: "简单描述您的业务和需求",
    submit: "提交咨询",
  },
  notFound: {
    text: "页面不存在",
    back: "返回首页",
  },
};

export const extraEn = {
  serviceLayout: {
    ctaTitle: "Ready to start?",
    defaultCta: "Book Consultation",
    images: {
      courses: { heroAlt: "Team planning a course roadmap", heroCaption: "Structured training compounds long-term influence", contentAlt: "Instructor teaching content strategy" },
      operations: { heroAlt: "Ops team reviewing growth dashboard", heroCaption: "Stable growth comes from repeatable structure", contentAlt: "Growth charts and KPI analysis" },
      ecommerce: { heroAlt: "Ecommerce team collaborating in warehouse scene", heroCaption: "Ecommerce growth needs content, conversion, and fulfillment", contentAlt: "Online shop order and product management" },
      interview: { heroAlt: "Two guests in interview set", heroCaption: "Authority needs real scenes and consistent output", contentAlt: "Professional interview gear in studio" },
      activity: { heroAlt: "Large-scale event with stage speech", heroCaption: "One event can become long-tail assets", contentAlt: "Audience interaction at event" },
      certification: { heroAlt: "Business professionals exchanging cards", heroCaption: "High-risk sectors need trust baseline first", contentAlt: "Certification documents and signing scene" },
      webDev: { heroAlt: "Developer building site system on laptop", heroCaption: "Modern websites serve users, search, and AI", contentAlt: "Frontend project in code editor" },
      consulting: { heroAlt: "Consulting team planning strategy", heroCaption: "Strategic rebuild turns complexity into systems", contentAlt: "Team mapping a growth roadmap" },
      matrix: { heroAlt: "Cross-functional matrix planning", heroCaption: "Matrix systems amplify multi-entry reach", contentAlt: "Team coordinating multi-channel tasks" },
      ipIncubation: { heroAlt: "Founder team discussing IP incubation", heroCaption: "IP incubation is long-term expression design", contentAlt: "Creators discussing content directions" },
      teamExpression: { heroAlt: "Team in expression training", heroCaption: "Expression consistency drives trust", contentAlt: "Group practicing communication" },
      contact: { heroAlt: "Consultant meeting client", heroCaption: "Start with one consultation, build durable growth", contentAlt: "Meeting table and notes" },
      default: { heroAlt: "Business team in office collaboration", heroCaption: "Systemized collaboration stabilizes growth", contentAlt: "Team reviewing business data" },
    },
  },
  pages: {
    activity: { title: "Event Amplification System", subtitle: "One event should live far beyond one day", cta: "Book Event Video Plan" },
    certification: { title: "Digital Trust Infrastructure", subtitle: "Verification is a trust entry, not a badge", cta: "Apply for Verification" },
    consulting: { title: "Influence Strategy Rebuild", subtitle: "Some issues are structural, not executional", cta: "Book 1-on-1 Consultation" },
    courses: { title: "Influence Architecture Camp", subtitle: "Not just video skills, but system design", cta: "View Course Packages" },
    ecommerce: { title: "Ecommerce Growth Structure", subtitle: "The core challenge is structure, not products", cta: "Get Ecommerce + Live Plan" },
    interview: { title: "Authority Amplification System", subtitle: "Interview is an influence lever, not just video", cta: "Book Interview Plan" },
    matrix: { title: "3D Influence Matrix", subtitle: "Not more accounts, but full-dimensional coverage", cta: "View Matrix Build" },
    ipIncubation: { title: "Omni-channel IP Architecture", subtitle: "We build IP systems, not account ops", cta: "Apply for IP Plan" },
    operations: { title: "Short Video Growth Ops", subtitle: "We build a durable traffic engine", cta: "Get Managed Ops Plan" },
    teamExpression: { title: "Expression Architecture System", subtitle: "In the digital era, expression is productivity", cta: "Book Expression + On-Camera" },
    webDev: { title: "Digital Infrastructure Website", subtitle: "Not just beautiful sites, but discoverable systems", cta: "Book Website Plan" },
    contact: { title: "Contact Us", subtitle: "Get a tailored growth plan and strategy call", cta: "Book Strategy Call" },
  },
  serviceDetail: {
    common: {
      introTitle: "Why system-level upgrade matters",
      introParagraphs: [
        "Short-term content can create visibility, but not stable high-quality growth.",
        "Durable outcomes come from reusable and compounding system architecture.",
      ],
      emphasis: "Build structure first, then scale distribution.",
      sections: [
        {
          title: "Core Capabilities",
          items: [
            { title: "Structural Diagnosis", desc: "Identify bottlenecks and set priorities first." },
            { title: "Content System", desc: "Create reusable expression models, not one-off spikes." },
            { title: "Search + AI", desc: "Make content discoverable, understandable, and citable." },
          ],
        },
        {
          title: "Execution Method",
          items: [
            { title: "Phased Delivery", desc: "Scale by stages aligned to goals and resources." },
            { title: "Cross-channel Coordination", desc: "Connect short-form, website, search, and CRM." },
            { title: "Continuous Iteration", desc: "Optimize architecture with data, not vanity metrics." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["High-ticket service teams", "Long-term brand builders", "Multilingual expansion plans", "Search and AI-focused operators"],
      faqTitle: "FAQ",
      faqs: [
        { q: "When can we see change?", a: "Typically 2-4 weeks for structure signals, 8-12 weeks for stable outcomes." },
        { q: "Do you support multilingual?", a: "Yes, and additional languages can be extended later." },
        { q: "Can we work in phases?", a: "Yes. Start with the most critical module, then scale." },
      ],
      outro: ["Growth is not a single trick.", "Growth is a systems discipline."],
    },
    webDev: {
      introTitle: "A website is not a brochure. It is growth infrastructure.",
      introParagraphs: [
        "After 2025, website value is not visual display alone. It is whether your brand can be found, understood by AI, and cited over time.",
        "We do not just design pages. We build a three-layer system for humans, search engines, and AI models.",
        "Your site should be the hub of your cross-channel content network, not an isolated asset.",
      ],
      emphasis: "Half for people, half for search and AI.",
      sections: [
        {
          title: "Three-Layer Website Architecture",
          items: [
            { title: "Human Experience Layer", desc: "Clear navigation, conversion paths, visual trust, and case presentation to drive real actions." },
            { title: "Search Structure Layer", desc: "Keyword mapping, semantic headings, internal linking, and crawlable architecture for long-term organic traffic." },
            { title: "AI-Readable Layer", desc: "Q&A-oriented sections, structured data, and semantic clarity to improve model comprehension and citations." },
          ],
        },
        {
          title: "Core Deliverables",
          items: [
            { title: "SEO + Schema", desc: "Foundational SEO architecture with FAQ and Schema markup to make content discoverable and machine-readable." },
            { title: "Multilingual Framework", desc: "Chinese and English by default, expandable to more languages with localization beyond literal translation." },
            { title: "Content Compounding System", desc: "Blog and topic structures that turn short-form, interviews, and events into long-tail assets." },
            { title: "Conversion + Integrations", desc: "Form automation, CRM integration, and lead-routing logic for measurable business outcomes." },
          ],
        },
        {
          title: "Amplification Strategy",
          items: [
            { title: "Cross-Platform Coordination", desc: "Website, short-form, social, search, and AI entry points work as one system." },
            { title: "Online + Offline Loop", desc: "Events and interviews are converted into durable site assets to strengthen trust and search presence." },
            { title: "Compounding Asset Logic", desc: "Build reusable, citable, and searchable assets instead of chasing short-term traffic spikes." },
          ],
        },
        {
          title: "Website Development Scope",
          items: [
            { title: "Site Types", desc: "Brand, marketing, management, and ecommerce sites planned end-to-end." },
            { title: "Brand + Information Architecture", desc: "Clarify positioning and conversion pathways before design." },
            { title: "Visual Design + Frontend", desc: "Custom UI and frontend build, not template reuse." },
            { title: "Responsive Delivery", desc: "Optimized for mobile, tablet, and desktop." },
            { title: "Feature + Integrations", desc: "Forms, booking, blog/news, and integrations with email/WhatsApp/WeChat/CRM." },
            { title: "SEO Foundations", desc: "Keyword mapping, meta structure, and on-site SEO basics." },
            { title: "Launch + Enablement", desc: "Deployment, basic operations, and training for future updates." },
            { title: "Optional App Build", desc: "Custom iOS/Android application delivery when needed." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["High-ticket and trust-heavy industries", "Teams building long-term brand equity", "Operators targeting multilingual audiences", "Businesses needing SEO + AI visibility"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Do you deliver web design or a growth system?", a: "A growth system. Design is one layer, while structure, semantics, and conversion are the core." },
        { q: "Do you account for AI search and answer engines?", a: "Yes. We design AI-readable structures, FAQ modules, and structured data for better model understanding." },
        { q: "Do you support bilingual delivery?", a: "Yes. Chinese and English are supported, with expansion options for additional languages." },
        { q: "Can this work with short-form and social channels?", a: "Yes. The site acts as the central repository that coordinates social, short-form, search, and AI entries." },
        { q: "How do budget and timeline work?", a: "Scope depends on page volume, language count, content depth, and integration complexity. We recommend a diagnostic first." },
      ],
      outro: ["A website is not a one-off deliverable.", "It is your long-term growth infrastructure."],
    },
    ipIncubation: {
      introTitle: "We do not operate accounts. We build a 3D IP system.",
      introParagraphs: [
        "In the digital era, IP does not belong to a single platform. It belongs to a network of entry points, semantics, and trust assets.",
        "If influence lives on only one platform, it is an account, not an IP.",
        "We use a five-layer model to turn personal or team visibility into a durable influence system.",
      ],
      emphasis: "Omni-channel. Multilingual. Multi-entry. Sustainable.",
      sections: [
        {
          title: "Five-Layer IP Model",
          items: [
            { title: "Content Layer", desc: "Short-form, long-form, articles, interviews, and event assets express one consistent positioning." },
            { title: "Platform Layer", desc: "TikTok, YouTube, Instagram, Xiaohongshu, WeChat channels, search, and AI entries are coordinated." },
            { title: "Semantic Layer", desc: "FAQ, keyword architecture, and Schema improve search visibility and AI comprehension." },
            { title: "Trust Layer", desc: "Cases, interviews, certifications, and media signals compound industry trust." },
            { title: "Monetization Layer", desc: "Offer architecture, service tiers, and conversion pathways create business closure." },
          ],
        },
        {
          title: "Delivery Path",
          items: [
            { title: "Positioning Architecture", desc: "Define market position, core labels, and differentiated narratives." },
            { title: "Content Network Build", desc: "Create cross-platform cadence plus deep site assets to avoid spike-and-drop cycles." },
            { title: "AI Visibility Design", desc: "Build Q&A structure, FAQ pages, and semantic templates for higher citation potential." },
            { title: "Trust Asset Compounding", desc: "Use real scenes, proof, and authority expression to support high-ticket decisions." },
          ],
        },
        {
          title: "Execution Method",
          items: [
            { title: "Project-Based Sprinting", desc: "Weekly strategy sessions, direction reviews, and iterative optimization." },
            { title: "Cross-Function Collaboration", desc: "Content, operations, site, and conversion modules stay aligned to one outcome." },
            { title: "Data-Led Iteration", desc: "Track not only views but also search, lead quality, and conversion signals." },
          ],
        },
        {
          title: "IP Incubation Deliverables",
          items: [
            { title: "Persona + Messaging Tags", desc: "Define clear persona labels and messaging anchors." },
            { title: "Content + Topic Matrix", desc: "Build a sustainable topic and content system." },
            { title: "Multi-Account Growth Layout", desc: "Coordinate platform entries for broader organic reach." },
            { title: "Monetization Path Design", desc: "Map consultation and service capture to create closure." },
            { title: "Project-Based Deep Support", desc: "Structured delivery with strategy and execution alignment." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Founders and core teams in high-ticket sectors", "Brands scaling beyond one platform", "Operators prioritizing SEO + AI visibility", "Teams ready for system-level upgrade"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Is IP incubation platform-specific?", a: "No. We build an omni-channel system, not single-platform account operations." },
        { q: "Does this include website and search optimization?", a: "Yes. We include site architecture, FAQ, SEO foundations, and AI-readable structure." },
        { q: "How soon can we see changes?", a: "Typically 2-4 weeks for structural signals and 8-12 weeks for more stable growth outcomes." },
        { q: "Do you guarantee rank #1 or virality?", a: "No. We guarantee clear architecture, coherent positioning, and an iterative growth framework." },
        { q: "Is this suitable for complete beginners?", a: "Possible after assessment, but it is best for teams with baseline business foundations." },
      ],
      outro: ["IP is not a platform asset.", "IP is a durable influence asset."],
    },
    operations: {
      introTitle: "Short-form operations is not posting. It is traffic engineering.",
      introParagraphs: [
        "Platform distribution rewards structure, not randomness.",
        "We build durable growth engines through content cadence, entry strategy, search synergy, and data iteration.",
        "The objective is stable lead generation and brand compounding, not one-off spikes.",
      ],
      emphasis: "Operate with systems, not luck.",
      sections: [
        {
          title: "Traffic Structure Design",
          items: [
            { title: "Content Layers", desc: "Separate top-of-funnel, trust, and conversion content so each asset has a clear role." },
            { title: "Entry Coordination", desc: "Connect recommendation feeds, search, profile pathways, and website capture." },
            { title: "Cadence Management", desc: "Run weekly publishing and review cycles to sustain quality and momentum." },
          ],
        },
        {
          title: "Execution + Optimization",
          items: [
            { title: "Topic System", desc: "Build reusable topic pools from customer intent and business priorities." },
            { title: "Metric Stack", desc: "Track completion, engagement, search, inquiries, and lead quality together." },
            { title: "Iteration Loop", desc: "Continuously improve hooks, structure, messaging, and CTA logic." },
          ],
        },
        {
          title: "Managed Ops Deliverables",
          items: [
            { title: "Account Audit + Strategy", desc: "Assess current state and set phased goals." },
            { title: "Account Setup + Visuals", desc: "Structure, visual consistency, and baseline standards." },
            { title: "Content + Topic Planning", desc: "Build topic pools and content structure for stability." },
            { title: "Script Optimization", desc: "Improve titles, hooks, and structure for retention and conversion." },
            { title: "On-Site Capture", desc: "Scenario-based filming and asset capture." },
            { title: "Editing + Packaging", desc: "Editing, captions, rhythm, and cover optimization." },
            { title: "Engagement + Matrix Distribution", desc: "Strengthen interactions and cross-account distribution." },
            { title: "Publishing + Search Management", desc: "Stable cadence and search tag management." },
            { title: "Ad + Private Domain Support", desc: "Optional paid amplification and private domain routing." },
            { title: "Data Monitoring + Review", desc: "Weekly review of KPIs and content performance." },
            { title: "Consulting Support", desc: "Ongoing structural guidance and execution advice." },
          ],
        },
        {
          title: "Content Output Types",
          items: [
            { title: "Persona Videos", desc: "Strengthen credibility and personal positioning." },
            { title: "Search-Intent Videos", desc: "Target keywords and high-intent questions." },
            { title: "Traffic Videos", desc: "Expand top-of-funnel reach." },
            { title: "Marketing Videos", desc: "Drive conversion actions and inquiries." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Teams with clear business goals", "Brands needing stable lead flow", "Operators aligning short-form with websites", "Teams committed to data-driven iteration"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Is this just managed posting?", a: "No. We deliver a full operating system for traffic structure and growth loops." },
        { q: "When can we expect changes?", a: "Usually 2-4 weeks for structural movement and 8-12 weeks for more stable business signals." },
        { q: "Does it include search and AI visibility?", a: "Yes. We connect short-form output with site assets, FAQ, and search intent layers." },
      ],
      outro: ["Short-form ops is not volume play.", "It is repeatable growth engineering."],
    },
    matrix: {
      introTitle: "A matrix is not more accounts. It is multidimensional coverage.",
      introParagraphs: [
        "Single-platform multi-account setups are account matrices, not influence matrices.",
        "We build coordinated systems across platforms, languages, entry points, content forms, and role functions.",
        "The goal is wider effective reach and unified brand asset compounding.",
      ],
      emphasis: "Account count is form. Coverage architecture is substance.",
      sections: [
        {
          title: "Five-Dimension Matrix Model",
          items: [
            { title: "Platform Dimension", desc: "Each platform serves a specific job: reach, depth, search, or conversion." },
            { title: "Audience Dimension", desc: "Map messaging by intent stage across different decision segments." },
            { title: "Language Dimension", desc: "Bilingual structure expands access to multi-ethnic North American markets." },
            { title: "Content Dimension", desc: "Short-form, interviews, FAQ, cases, and site pages operate as one network." },
            { title: "Data Dimension", desc: "Use unified dashboards to optimize resource allocation by real outcomes." },
          ],
        },
        {
          title: "Operating Mechanism",
          items: [
            { title: "Role Architecture", desc: "Founder, brand, and scenario accounts collaborate without narrative conflict." },
            { title: "Asset Hub", desc: "Build reusable asset libraries for faster cross-platform production." },
            { title: "Conversion Closure", desc: "All matrix entries route into website and consultation paths." },
          ],
        },
        {
          title: "Matrix Account Build",
          items: [
            { title: "Brand Account", desc: "Unified brand positioning with official inquiry routing." },
            { title: "Founder IP Account", desc: "Personal narrative and expertise build deeper trust." },
            { title: "Avatar Accounts", desc: "Coverage across different interest clusters and labels." },
            { title: "Multi-Account Coordination", desc: "One brand, multiple entry points, unified conversion." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Teams with existing content foundations", "Brands scaling cross-platform visibility", "Operators needing message consistency", "Businesses planning long-term matrix expansion"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Do we need many accounts?", a: "Not necessarily. Entry architecture and role design matter more than account quantity." },
        { q: "Will matrix work create duplicate content?", a: "We adapt format and role per platform while maintaining one strategic narrative." },
        { q: "How do you evaluate matrix effectiveness?", a: "By coverage quality, search performance, lead quality, and conversion efficiency." },
      ],
      outro: ["A matrix is not account stacking.", "It is system-level coverage."],
    },
    courses: {
      introTitle: "This is not a video class. It is an influence architecture bootcamp.",
      introParagraphs: [
        "Most programs teach tactics but fail to create durable competitiveness.",
        "Our core is a five-layer system: positioning, content, search, trust, and monetization.",
        "You build not just output skills, but a reusable influence operating model.",
      ],
      emphasis: "System first, tactics second.",
      sections: [
        {
          title: "Core Training Modules",
          items: [
            { title: "Positioning Architecture", desc: "Define clear labels and differentiated narratives that market remembers." },
            { title: "Content Structure", desc: "Master repeatable content frameworks for consistent delivery." },
            { title: "Search + AI", desc: "Extend message visibility to long-tail search and AI channels." },
            { title: "Trust Infrastructure", desc: "Use cases, interviews, and authority expression to reduce decision friction." },
            { title: "Monetization Path", desc: "Build consultation and service capture pathways from day one." },
          ],
        },
        {
          title: "Training Format",
          items: [
            { title: "Structured Sprints", desc: "Weekly progression and checkpoints to ensure real execution." },
            { title: "Live Assignments", desc: "Work on real business scenarios, not detached classroom demos." },
            { title: "Template Toolkit", desc: "Frameworks, checklists, and SOP assets for ongoing team reuse." },
          ],
        },
        {
          title: "Package 1 | Self-Media Acquisition Model",
          items: [
            { title: "Account Positioning + Topic Logic", desc: "Start from zero with clear tags for search discovery." },
            { title: "Short-Form Copy + Viral Structure", desc: "Eight proven templates to strengthen hooks and narrative." },
            { title: "Filming + Editing", desc: "Core techniques to improve rhythm and visual quality." },
            { title: "Execution + Conversion", desc: "Hands-on workflows that connect content to inquiries." },
            { title: "Drone Module", desc: "Theory + hands-on training for cinematic capture." },
          ],
        },
        {
          title: "Package 1 | Service Add-ons",
          items: [
            { title: "Four-Week Search Program", desc: "Search and tag structure for sustainable acquisition." },
            { title: "Overseas Video Account Support", desc: "Account setup and baseline configuration assistance." },
            { title: "Professional Account Assistance", desc: "Xiaohongshu/Video account verification guidance." },
            { title: "Private Domain + Auto Reply", desc: "Auto-reply, private traffic routing, and growth support." },
            { title: "Copy Guidance + Tools", desc: "Copy guidance and curated creator toolkits." },
            { title: "Retraining Support", desc: "Multiple retraining opportunities within three months." },
            { title: "Phase-Based Ops Support", desc: "High-end ops support and real-world execution." },
            { title: "Drone Usage Support", desc: "On-site drone usage support when needed." },
          ],
        },
        {
          title: "Package 2 | Ecommerce Growth Bootcamp",
          items: [
            { title: "SEO Traffic Breakthrough", desc: "Launch logic, tag positioning, and ecommerce account structure." },
            { title: "High-Conversion Video Templates", desc: "Reusable scripts and conversion-focused storytelling." },
            { title: "Hands-on Sprint", desc: "Guided production of product recommendation videos." },
            { title: "Live Commerce Playbook", desc: "Performance training, product selection, scripts, and flow." },
            { title: "AI Efficiency Module", desc: "AI-assisted product selection, scripts, and messaging." },
          ],
        },
        {
          title: "Package 2 | Service Add-ons",
          items: [
            { title: "Five-Week Ecommerce Program", desc: "Complete curriculum and execution cadence." },
            { title: "US TikTok Entry Support", desc: "Support for platform entry and baseline setup." },
            { title: "Live Scripts Handbook", desc: "High-conversion live commerce script framework." },
            { title: "Shop Window Setup", desc: "Assistance with shop window setup and configuration." },
            { title: "Copy Guidance + Tools", desc: "Copy guidance and curated creator toolkits." },
            { title: "Retraining Support", desc: "Multiple retraining opportunities within three months." },
            { title: "AI Tool Support", desc: "Guidance for AI tools to improve efficiency." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Local businesses and chain brands", "Studios, local service teams, and creators", "Ecommerce sellers and personal IP commerce", "Brand live-stream teams and supply chains"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Is this only for beginners?", a: "Beginners can join, but it is strongest for teams with existing business foundations." },
        { q: "Do you guarantee virality?", a: "No. We guarantee durable structure and repeatable growth capability." },
        { q: "Can we continue after the bootcamp?", a: "Yes. You can extend into operation systems or focused implementation tracks." },
      ],
      outro: ["Training is the starting point.", "System capability is the moat."],
    },
    ecommerce: {
      introTitle: "Ecommerce growth is not about selling harder. It is about growth architecture.",
      introParagraphs: [
        "Promotions can lift short-term sales, but sustainable growth requires coordinated systems.",
        "We align content, search, trust assets, landing structure, and conversion pathways.",
        "Every traffic source should feed a reusable growth network.",
      ],
      emphasis: "Ecommerce is not a traffic game. It is a systems discipline.",
      sections: [
        {
          title: "Growth Architecture Modules",
          items: [
            { title: "Content Acquisition", desc: "Attract qualified demand with scenario-driven content." },
            { title: "Search Capture", desc: "Use keyword architecture and topic pages for high-intent capture." },
            { title: "Trust Reinforcement", desc: "Deploy proof assets, testimonials, interviews, and credibility signals." },
            { title: "Conversion Funnel", desc: "Optimize inquiry, checkout, and retention paths end-to-end." },
          ],
        },
        {
          title: "Operating System",
          items: [
            { title: "Product + Content Alignment", desc: "Align content with margin strategy and target demand." },
            { title: "Cross-Channel Coordination", desc: "Short-form, social, search, site, and CRM work as one funnel." },
            { title: "Weekly Analytics", desc: "Track quality traffic, conversion rate, AOV, and repeat-purchase signals." },
          ],
        },
        {
          title: "Livestream Operations",
          items: [
            { title: "Live Room Setup", desc: "Set up live room, process flow, and script structure." },
            { title: "Ops + Review", desc: "Run live operations, track data, and optimize after each session." },
            { title: "Presenter Focus", desc: "You focus on product and on-camera delivery; we handle operations." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Cross-border and local ecommerce teams", "High-ticket or complex-consideration offers", "Brands pursuing long-term compounding", "Teams needing acquisition-conversion alignment"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Do you only run ads?", a: "No. We focus on durable organic structure and conversion systems; ads can amplify later." },
        { q: "Do you support multilingual ecommerce?", a: "Yes. We localize keywords, page structure, and messaging by market language." },
        { q: "Can this integrate with IP strategy?", a: "Yes. IP + ecommerce integration typically improves trust and conversion quality." },
      ],
      outro: ["Durable ecommerce growth needs structure.", "Not one-time spikes."],
    },
    interview: {
      introTitle: "Interview is not a format. It is authority infrastructure.",
      introParagraphs: [
        "In high-ticket markets, trust drives conversion quality.",
        "Interview systems turn expertise, real scenes, and third-party signals into durable credibility assets.",
        "We transform one interview into a searchable, distributable, and citable content network.",
      ],
      emphasis: "Interview is not one video. It is a trust layer.",
      sections: [
        {
          title: "Interview System Design",
          items: [
            { title: "Topic Architecture", desc: "Design topics around buyer decisions, not generic talking points." },
            { title: "Narrative Framework", desc: "Refine sequence, argument density, and authority cues." },
            { title: "Asset Repurposing", desc: "Split one session into short-form, long-form, article, and FAQ assets." },
          ],
        },
        {
          title: "Trust Compounding Path",
          items: [
            { title: "Website Depth Pages", desc: "Convert interviews into long-tail searchable authority pages." },
            { title: "Credibility Layer", desc: "Connect guests, cases, events, and validation signals." },
            { title: "Conversion Capture", desc: "Place consultation pathways at key trust moments." },
          ],
        },
        {
          title: "Interview Video Service",
          items: [
            { title: "Interview Planning", desc: "Design topics and prompts based on audience and business goals." },
            { title: "On-Site Filming", desc: "Professional filming, lighting, and audio capture." },
            { title: "Post-Production", desc: "Multi-version edits and content repurposing for channels." },
            { title: "Format Customization", desc: "Adjust length and format to fit distribution strategy." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Trust-heavy personal brands", "Teams building authority positioning", "Brands with content but weak trust", "High-ticket operators improving conversion"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Is interview suitable for every industry?", a: "Most effective in high-ticket, trust-intensive sectors with longer decision cycles." },
        { q: "Is interview hard to sustain?", a: "We design topic pipelines and repurposing flows for sustainable output." },
        { q: "How does interview drive business outcomes?", a: "Through website authority assets, search visibility, and structured conversion capture." },
      ],
      outro: ["Authority comes from sustained expression.", "Interview is a trust amplifier."],
    },
    activity: {
      introTitle: "An event should not live for one day. It should compound long-term influence.",
      introParagraphs: [
        "Most events lose value after the venue closes.",
        "We convert events from one-time occurrences into structured content asset projects.",
        "With systematic repurposing and distribution, one event can generate lasting traffic and trust.",
      ],
      emphasis: "One event. Multiple waves. Long-tail value.",
      sections: [
        {
          title: "Event Amplification Structure",
          items: [
            { title: "Pre-Event Warmup", desc: "Prime audience intent with agenda-led pre-event messaging." },
            { title: "On-Site Capture", desc: "Capture speeches, interactions, proof scenes, and key narrative moments." },
            { title: "Post-Event Repurposing", desc: "Split into short-form, articles, FAQ, and topic pages for ongoing distribution." },
          ],
        },
        {
          title: "Asset + Conversion Path",
          items: [
            { title: "Search Compounding", desc: "Convert event insights into indexable long-tail pages." },
            { title: "Trust Proof", desc: "Leverage live scenes, guest statements, and audience feedback as credibility assets." },
            { title: "Business Capture", desc: "Route event traffic into consultation pathways with measurable outcomes." },
          ],
        },
        {
          title: "Event Video Service",
          items: [
            { title: "Event Coverage Capture", desc: "Capture speeches, interactions, and key moments across the event." },
            { title: "Fast Turnaround Editing", desc: "Support same-day or post-event edits when needed." },
            { title: "Multi-Version Output", desc: "Deliver short-form clips, highlight reels, and recap videos." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Teams hosting recurring events", "Brands improving event ROI", "Businesses repurposing event assets", "Operators building trust-led growth"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Can growth continue after the event?", a: "Yes, if post-event structure and website compounding are designed upfront." },
        { q: "Do you only provide filming?", a: "No. We deliver the full amplification system: structure, repurposing, and conversion flow." },
        { q: "How do you measure event amplification?", a: "Through reach quality, search indexing, lead conversion, and reuse efficiency." },
      ],
      outro: ["An event is a starting point.", "Not the end of influence."],
    },
    certification: {
      introTitle: "Certification is not a badge. It is digital trust infrastructure.",
      introParagraphs: [
        "In high-risk and high-ticket sectors, trust comes before conversion.",
        "Certification only works when integrated with content, site architecture, and proof systems.",
        "We turn credentials into searchable, understandable, and conversion-ready trust structures.",
      ],
      emphasis: "Raise trust baseline first, then scale traffic.",
      sections: [
        {
          title: "Digital Trust Architecture",
          items: [
            { title: "Credential Visibility", desc: "Present compliance and certification signals in clear structured formats." },
            { title: "Proof Chain", desc: "Connect credentials, interviews, cases, and customer evidence into one trust narrative." },
            { title: "Semantic Clarity", desc: "Answer key objections via clear terminology and FAQ for search + AI understanding." },
          ],
        },
        {
          title: "Implementation System",
          items: [
            { title: "Trust Page Stack", desc: "Build credential, process, risk, and FAQ pages for high-intent users." },
            { title: "Cross-Channel Consistency", desc: "Align short-form, website, and consultation messaging." },
            { title: "Conversion Layer", desc: "Deploy capture points at high-trust moments to improve qualified leads." },
          ],
        },
        {
          title: "Account Opening + Professional Verification",
          items: [
            { title: "Video Account + Xiaohongshu Verification", desc: "Support enterprise/personal verification workflows across platforms." },
            { title: "High-Risk Industry Compliance", desc: "Experienced with finance, real estate, insurance, immigration, and other trust-sensitive sectors." },
            { title: "Platform + Account Type Selection", desc: "Choose the right platform mix and account types for your goals." },
            { title: "Credential Preparation", desc: "Prepare business documents, scope, and brand materials to meet platform requirements." },
            { title: "Naming Strategy", desc: "Design names with higher approval probability and lower risk flags." },
            { title: "Blue V + Video Account Launch", desc: "Complete verification and launch so clients can find you fast." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Finance and insurance sectors", "Immigration and education consulting", "High-ticket professional services", "Teams improving trust-to-conversion ratio"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Does certification alone improve conversion?", a: "Not by itself. It must be embedded into full trust and conversion architecture." },
        { q: "Does this include trust pages on the website?", a: "Yes. We design credential narratives, FAQs, and action pathways together." },
        { q: "Is this only for large enterprises?", a: "No. It is most useful for trust-sensitive businesses regardless of size." },
      ],
      outro: ["Certification opens trust.", "Structure drives conversion."],
    },
    teamExpression: {
      introTitle: "Team expression is not script alignment. It is brand cognition alignment.",
      introParagraphs: [
        "Many teams publish content but speak with inconsistent narratives.",
        "We upgrade expression into a trainable, reusable, and scalable system.",
        "Founders, sales, consultants, and operators communicate through one coherent narrative architecture.",
      ],
      emphasis: "Expression consistency is brand productivity.",
      sections: [
        {
          title: "Expression Architecture",
          items: [
            { title: "Core Narrative Line", desc: "Define brand stance, core terms, and value propositions." },
            { title: "Role Messaging System", desc: "Build role-specific templates while preserving one strategic voice." },
            { title: "Scenario Templates", desc: "Cover short-form, livestream, DM, consultation, and offline touchpoints." },
          ],
        },
        {
          title: "Training + Deployment",
          items: [
            { title: "Expression Training", desc: "Improve on-camera delivery, logic flow, and objection handling." },
            { title: "Co-Creation Workflow", desc: "Turn expression from individual talent into organizational capability." },
            { title: "Review Loop", desc: "Optimize messaging using audience response and conversion signals." },
          ],
        },
        {
          title: "Team On-Camera Service",
          items: [
            { title: "On-Camera Plan Assessment", desc: "Assess required people, content focus, and video duration." },
            { title: "Team Members On Camera", desc: "Team members can appear on camera in place of founders." },
            { title: "Batch Delivery", desc: "Structured batch output with delivery cadence over time." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Service teams with multiple spokespeople", "Founder-led brands", "Organizations needing message consistency", "Teams improving consultation conversion quality"],
      faqTitle: "FAQ",
      faqs: [
        { q: "How is this different from normal script training?", a: "This is a full system design, not one-off coaching sessions." },
        { q: "Is it only for founders?", a: "No. It is built for multi-role team alignment across public touchpoints." },
        { q: "How do you measure impact?", a: "By consistency quality, communication efficiency, lead quality, and conversion outcomes." },
      ],
      outro: ["Expression is an organizational asset.", "Consistency amplifies brand value."],
    },
    consulting: {
      introTitle: "Strategic consulting is not advice delivery. It is system re-architecture.",
      introParagraphs: [
        "When growth remains unstable, the root issue is usually structural, not tactical.",
        "We reverse-map from business goals to content, channel, trust, search, and conversion architecture.",
        "The outcome is an executable, measurable, and continuously optimizable growth system.",
      ],
      emphasis: "Rebuild structure first, then improve execution velocity.",
      sections: [
        {
          title: "Strategic Diagnosis Framework",
          items: [
            { title: "Constraint Identification", desc: "Locate bottlenecks across traffic, trust, capture, and team coordination." },
            { title: "Priority Pathing", desc: "Set phased goals and resource focus to reduce organizational friction." },
            { title: "Risk Control", desc: "Define boundaries and acceptance criteria before execution." },
          ],
        },
        {
          title: "Rebuild Outputs",
          items: [
            { title: "System Blueprint", desc: "Deliver integrated architecture across content, channels, website, AI visibility, and conversion." },
            { title: "Execution Roadmap", desc: "Break strategy into weekly and monthly actionable tracks." },
            { title: "Review Mechanism", desc: "Implement feedback loops for continuous structural optimization." },
          ],
        },
        {
          title: "1-on-1 Deep Consultation",
          items: [
            { title: "High-Density Strategy", desc: "For founders and IPs who need executable answers fast." },
            { title: "Problem Deconstruction", desc: "No small talk, only actionable structure and priorities." },
            { title: "Phase-Based Guidance", desc: "Clear next actions and decision checkpoints." },
          ],
        },
      ],
      fitTitle: "Best Fit",
      fitItems: ["Teams investing heavily with unstable outcomes", "Organizations with cross-channel coordination issues", "High-ticket trust-sensitive sectors", "Businesses requiring staged strategic reset"],
      faqTitle: "FAQ",
      faqs: [
        { q: "Will this remain theoretical?", a: "No. We provide architecture plus execution paths and review criteria." },
        { q: "Do you support implementation?", a: "Yes, phased support can be included based on scope." },
        { q: "How do we know we need a rebuild?", a: "If traffic, conversion, and team coordination stay volatile and unexplained, structure-level reset is usually required." },
      ],
      outro: ["Growth is not doing more tasks.", "It is solving the right structural constraints."],
    },
  },
  contact: {
    cards: [
      { label: "Phone", value: "4373624422" },
      { label: "WeChat", value: "" },
      { label: "Email", value: "info@traffynity.com" },
    ],
    formTitle: "Book Strategy Call",
    name: "Name",
    namePlaceholder: "Your name",
    channel: "Contact",
    channelPlaceholder: "Phone / WeChat / Email",
    need: "Your Needs",
    needPlaceholder: "Briefly describe your business and goals",
    submit: "Submit",
  },
  notFound: {
    text: "Oops! Page not found",
    back: "Return to Home",
  },
};
